import { hashValue } from '@games/core'
import type { FogChessState } from './types'

function serializeBoard(state: FogChessState): string {
  const rows: string[] = []
  for (const row of state.board) {
    let line = ''
    for (const cell of row) line += cell ? `${cell.color}${cell.type}` : '..'
    rows.push(line)
  }
  return rows.join('/')
}

/** 确定性状态指纹，用于两端一致性校验。 */
export function hashState(state: FogChessState): string {
  const payload = [
    serializeBoard(state),
    state.turn,
    state.winner ?? '-',
    String(state.moveCount),
    state.lastMove
      ? `${state.lastMove.from.r},${state.lastMove.from.c}>${state.lastMove.to.r},${state.lastMove.to.c}`
      : '-',
    state.captured.r.join(','),
    state.captured.b.join(','),
  ].join('|')
  return hashValue(payload)
}